import { IAddressInfo } from '@/models';

const hasRenderableAddress = (addressInfo?: IAddressInfo): boolean => {
  const address = addressInfo?.address;

  return Boolean(
    address && typeof address === 'object' && Object.keys(address).length > 0,
  );
};

export const getMapAddressInfo = (
  formAddressInfo?: IAddressInfo,
  persistedAddressInfo?: IAddressInfo,
): IAddressInfo | undefined => {
  if (!formAddressInfo) {
    return persistedAddressInfo;
  }

  if (hasRenderableAddress(formAddressInfo)) {
    return formAddressInfo;
  }

  if (!hasRenderableAddress(persistedAddressInfo)) {
    return {
      ...formAddressInfo,
      locationPoints: formAddressInfo.locationPoints?.length
        ? formAddressInfo.locationPoints
        : persistedAddressInfo?.locationPoints,
    };
  }

  return {
    ...formAddressInfo,
    locationPoints: undefined,
  };
};
